define('models/pages/favorites/index',['require','models/base/model','helpers/application','models/pages/favorites/providers','models/pages/favorites/goods'],function(require) {
    'use strict';

    var Model = require('models/base/model'),
        applicationHelper = require('helpers/application'),
        FavoritesProviders = require('models/pages/favorites/providers'),
        FavoritesGoods = require('models/pages/favorites/goods');

    var FavoritesPageViewModel = Model.extend({
        urlPath: '/page/favorites',

        defaults: {
        },

        constructor: function() {
            Model.apply(this, arguments);

            var self = this;

            var data = {
                page: this.get('page'),
                favFilter: this.get('favFilter')
            };

            this.providers = new FavoritesProviders(data);
            this.goods = new FavoritesGoods(data);

            this.providers.on('loading', function(){
                if(data.favFilter === 'favs' && this.providers.models.length === 0){
                    return applicationHelper.redirectTo('favorites#show', { page: data.page, favFilter: 'all' });
                }
            });

            this.goods.on('loading', function(){
                if(data.favFilter === 'favs' && this.get('items').length === 0){
                    return applicationHelper.redirectTo('favorites#show', { page: data.page, favFilter: 'all' });
                }
            });


            this[this.get('page')].load(true);
        },
        parse: function(data){
            this.providers.set(data.providers);
            this.goods.set(data.goods);
            return data;
        },
        load: function(a) {
            this[this.get('page')].load(a);
        },
        dispose: function() {
            if (this.disposed) { return; }
            this.providers.dispose();
            this.goods.dispose();
            Model.prototype.dispose.apply(this, arguments);
        }
    });


    return FavoritesPageViewModel;
});
